import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const ContentContainer = ({ width, children, className }) => {
  return <section className={cn('content-container', width, className )}>{children}</section>;
};

ContentContainer.defaultProps = {
  width: 'wide',
  className: '',
};

ContentContainer.propTypes = {
  className: PropTypes.string,
  width: PropTypes.oneOf(['small', 'wide']),
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

export default ContentContainer;
